// src/redux/technologie/actions.js

export const SET_TECHNOLOGIES = 'SET_TECHNOLOGIES';
export const ADD_TECHNOLOGIE = 'ADD_TECHNOLOGIE';
export const UPDATE_TECHNOLOGIE = 'UPDATE_TECHNOLOGIE';
export const DELETE_TECHNOLOGIE = 'DELETE_TECHNOLOGIE';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const RESET_FORM = 'RESET_FORM';

export const setTechnologies = (data) => ({ type: SET_TECHNOLOGIES, payload: data });
export const addTechnologie = (data) => ({ type: ADD_TECHNOLOGIE, payload: data });
export const updateTechnologie = (data) => ({ type: UPDATE_TECHNOLOGIE, payload: data });
export const deleteTechnologieById = (id) => ({ type: DELETE_TECHNOLOGIE, payload: id });
export const setLoading = (isLoading) => ({ type: SET_LOADING, payload: isLoading });
export const setError = (message) => ({ type: SET_ERROR, payload: message });
export const setFormData = (formData) => ({ type: SET_FORM_DATA, payload: formData });
export const resetForm = () => ({ type: RESET_FORM });
